// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","textGreen":"#009e66","link":"WFScOmMYcjf3PIrrp30Kj","buttonLink":"_3YoP0137Ei0GSeWV33oUc1 WFScOmMYcjf3PIrrp30Kj"};


//////////////////
// WEBPACK FOOTER
// ./src/common/glossary-entry/glossary-link/GlossaryLink.css
// module id = 480
// module chunks = 0 1 2